import { Tracking } from '@letsdothis/tracking';

import { useAppContext } from '@/context';
import { ContextName } from '@/appContext/contextName';

export const useTrackingLibrary = (): Tracking => {
  const { [ContextName.TRACKING]: tracking } = useAppContext();

  return tracking as Tracking;
};
